import ControlledRadioGroup from '../../../../shared/ControlledFields/ControlledRadioGroup';
import MultiStepForm from 'components/shared/MultiStepForm/MultiStepForm';
import { useTranslation } from 'react-i18next';

const DtrContent = ({ control }) => {
  const { t } = useTranslation('common', { keyPrefix: 'costCenterSettings' });

  return (
    <MultiStepForm.Section
      title={t('dtrCalculation.title')}
      fullPadding={false}
    >
      <ControlledRadioGroup
        control={control}
        name="dtr_calculation_enabled"
        label={''}
        options={[
          { label: t('dtrCalculation.yes'), value: 'true' },
          { label: t('dtrCalculation.no'), value: 'false' }
        ]}
        direction="row"
      />
    </MultiStepForm.Section>
  );
};

export default DtrContent;
